import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=a9bc7b40&scoped=true"
import script from "./TransactionsList.vue?vue&type=script&lang=js"
export * from "./TransactionsList.vue?vue&type=script&lang=js"
import style0 from "./TransactionsList.vue?vue&type=style&index=0&id=a9bc7b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bc7b40",
  null
  
)

export default component.exports